import React from 'react'
import { Image, Pressable } from 'react-native'

import { IMAGE } from '@ui-kit/assets/images/index.native'
import { downloadButtonConfiguration } from '@ui-kit/components/AppDownloadButtons/constants'

import type { IconProps } from './types'

const AndroidIcon = (_: IconProps) => {
  return (
    <Pressable {...downloadButtonConfiguration} accessibilityLabel="Download on the Play Store">
      <Image
        className="h-10 w-[135px]"
        source={IMAGE.illustrations.appDownloadButtons.playStore_135x40}
      />
    </Pressable>
  )
}

export default AndroidIcon
